import React from "react";
import { isNull } from "lodash";
import { useIntl, FormattedMessage } from "react-intl";
import { Box, VStack, StackDivider, Text } from "@chakra-ui/react";
import ItemRow from "./ItemRow";

import { modelTransactionBreakdownSummary, showTaxInclusiveMessage } from "flows/TxnHistory/utils";

const SPACING = 3;

/**
 * BreakdownSummary - Presentational component for displaying meta info like dates, status, etc
 * @param {object} props
 * @param {TxnVariant} props.transaction
 * @returns JSX.Element
 */
export default function BreakdownSummary({ transaction }) {
  const { formatMessage } = useIntl();

  const transactionBreakdownSummary = modelTransactionBreakdownSummary(transaction, formatMessage);

  /**
   * If this is an unsupported transaction_type,
   * we return null. It's up to whatever
   * is wrapping this component to show appropriate
   * messaging about non-supported transaction types.
   */
  if (isNull(transactionBreakdownSummary)) {
    return transactionBreakdownSummary;
  }

  const { summaryItems, lineItems, total, currency } = transactionBreakdownSummary;

  return (
    <Box pt={4}>
      <VStack align="left" spacing={SPACING} divider={<StackDivider />}>
        {lineItems.length > 0
          ? lineItems.map((li, i) => {
              return <ItemRow key={i} title={li.title} value={li.value} currency={li.currency} />;
            })
          : null}
        {summaryItems.length > 0 && (
          <VStack align="left" spacing={SPACING}>
            {summaryItems.map((si, i) => {
              return <ItemRow key={i} title={si.title} value={si.value} currency={si.currency} />;
            })}
          </VStack>
        )}
        <ItemRow
          title={formatMessage({
            defaultMessage: "Total",
            description: "Field label",
          })}
          value={total}
          currency={currency}
          boldTitle
          boldValue
          subtitle={
            showTaxInclusiveMessage(transaction) && (
              <Text as="i" fontSize="sm" w="100%" textAlign="right">
                *
                <FormattedMessage
                  defaultMessage="Price is inclusive of tax"
                  description="Means - Tax is included in price."
                />
              </Text>
            )
          }
        />
      </VStack>
    </Box>
  );
}
